import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Button, useMediaQuery } from '@mui/material'; // Correct import
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Navbar from 'components/Navbar';
// import { useGetUser Query } from 'state/api'; // This line has a syntax error

const Layout = () => {
  const isNonMobile = useMediaQuery("(min-width: 600px)");
  const userId = useSelector((state) => state.global.userId);
  // const { data, isLoading, error, refetch } = useGetUser Query(userId); // Syntax error here

  // useEffect(() => {
  //   console.log(data);
  // }, [data]);

  // if (isLoading) {
  //   return <CircularProgress />;
  // }

  // if (error) {
  //   return (
  //     <Box>
  //       <div>Error loading user data</div>
  //       <Button onClick={refetch}>Retry</Button>
  //     </Box>
  //   );
  // }

  return (
    <Box display="flex" flexDirection="column" width="100%" height="100%">
      <Navbar 
        // user={data || {}}
      />
      <Box flexGrow={1}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default Layout;